export default __webpack_public_path__ + "static/apy-b4bc2d551d11db07d7fa5fe28cc88b37.png";